var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom clearfix"},[_c('el-row',{attrs:{"gutter":5}},[_c('el-col',{attrs:{"lg":8}},[_c('PagePagination',{attrs:{"total":_vm.total},on:{"fetch":_vm.fetch}})],1),_c('el-col',{staticStyle:{"margin-top":"2px","float":"right"},attrs:{"lg":8}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }